import React from "react";

function NoPage() {
    return (
        <div className="content">
            <h1>Error 404</h1>
            <p>Page doesn't exist</p>
        </div>
    );
}

export default NoPage;
